import { Card, Skeleton, Stack, SxProps, useTheme } from "@mui/material";

interface IProps {
  sx?: SxProps;
  width?: number;
  variant?: "card" | "list";
}

const ItemSkeleton = (props: IProps) => {
  const theme = useTheme();

  const renderContent = () => (
    <Stack>
      <Stack direction="row" spacing={0.5} sx={{ alignItems: "center" }}>
        <Skeleton variant="circular" width={14} height={14} />
        <Skeleton width={props.width ? props.width : 300} height={26} />
      </Stack>

      <Stack direction="row" spacing={0.5} sx={{ pl: 1.25, alignItems: "center" }}>
        <Skeleton variant="circular" width={18} height={18} />
        <Skeleton width={30} height={30} />
        <Skeleton width={30} height={30} />
      </Stack>
    </Stack>
  );

  return props.variant === "card" ? (
    <Card sx={{ p: 0.5, border: `solid 1px ${theme.palette.line.main}`, ...props.sx }} elevation={0}>
      {renderContent()}
    </Card>
  ) : (
    renderContent()
  );
};

export { ItemSkeleton };
